export default "__VITE_ASSET__BQS_$TXs__"